import { INR, USD } from "features/Listings/Listings.constants";
import constants from "../../../constants/constants";

export const coupon_api_keys = {
  header: "header",
  tagline: "tagline",
  description: "description",
  button_text: "button_text",
  discount_uid: "discount_uid",
};

export const coupon_labels = {
  mobile_modal_title: "Customize Your Coupon",
  desktop_modal_title: "Customize Your Coupon Code",
  cta_text: "Create coupon",
  discount_code: "Discount Code",
  header: "Header *",
  tagline: "Tagline *",
  header_placeholder: "Enter header",
  tagline_placeholder: "Enter tagline",
  description: "Description *",
  description_placeholder: "Enter description",
  button_text: "Button Text *",
  button_text_placeholder: "Enter button text",
};

export const DISCOUNT_CODES_LEARN_MORE_HREFS = {
  DISCOUNT_CODES:
    "https://support.exlyapp.com/support/solutions/articles/84000347733-discount-codes-on-exly",
  DISCOUNT_CODES_VIDEO: "https://www.youtube-nocookie.com/embed/qHqSzJWFMAU",
};

export const COUPON_APPLICABLE_TYPE = {
  EVERYONE: 1,
  SPECIFIC_LISTINGS: 2,
  LOYALTY_USERS: 4,
  SPECIFIC_COMBOS: 5,
};

export const COUPON_APPLICABLE_TYPE_LABELS = {
  [COUPON_APPLICABLE_TYPE.EVERYONE]: "All Offerings",
  [COUPON_APPLICABLE_TYPE.SPECIFIC_LISTINGS]: "Specific Offerings",
  [COUPON_APPLICABLE_TYPE.LOYALTY_USERS]: "Loyal Customers",
  [COUPON_APPLICABLE_TYPE.SPECIFIC_COMBOS]: "Specific Combos",
};

export const COUPON_APPLICABLE_OPTIONS = [
  {
    label: "All Offerings",
    value: COUPON_APPLICABLE_TYPE.EVERYONE,
  },
  {
    label: "Specific Offerings",
    value: COUPON_APPLICABLE_TYPE.SPECIFIC_LISTINGS,
  },
  {
    label: "Specific Combos",
    value: COUPON_APPLICABLE_TYPE.SPECIFIC_COMBOS,
  },
  {
    label: "Loyal Customers",
    value: COUPON_APPLICABLE_TYPE.LOYALTY_USERS,
  },
];

export const DISCOUNT_CURRENCY_OPTIONS = [
  { label: INR, value: constants.inr },
  { label: USD, value: constants.usd },
];

export const STAT_CARDS = {
  VIEWS: {
    title: "Total Visitors",
  },
  LEADS: {
    title: "Total Leads",
  },
  BOOKINGS: {
    title: "Total Bookings",
  },
  REVENUE: {
    title: "Total Revenue",
  },
};

export const date_range_select_options = {
  last_7: { value: "last_7", label: "Last 7 days", days: 7 },
  last_30: { value: "last_30", label: "Last 30 days", days: 30 },
  lifetime: { value: "last_365", label: "Last 1 year", days: 365 },
  custom: { value: "custom", label: "Custom" },
};
export const DISCOUNT_TYPE = {
  AMOUNT: 2,
  PERCENTAGE: 1,
};

export const DISCOUNT_TYPE_OPTIONS = [
  { label: "Amount", value: DISCOUNT_TYPE.AMOUNT },
  { label: "Percentage", value: DISCOUNT_TYPE.PERCENTAGE },
];

export const DISCOUNT_VAULE_1 = 1;
export const DISCOUNT_STATS = "discountStats";
